// based on pegasus, a super simple XMLHttpRequest library
// https://github.com/typicode/pegasus
export function get(url) {
  const xhr = new XMLHttpRequest();

  // Open url
  xhr.open('GET', url);

  let callbacks = [];

  // onSuccess handler
  // onError   handler
  xhr.onreadystatechange = xhr.then = function handler(onSuccess, onError) {
    // Test if onSuccess is a function
    if (onSuccess && onSuccess.call) callbacks = [null, onSuccess, onError];

    // Test if request is complete
    if (xhr.readyState === 4) {
      // index will be:
      // 0 if undefined
      // 1 if status is between 200 and 399
      // 2 if status is over
      const cb = callbacks[+xhr.status / 200];

      // Safari doesn't support xhr.responseType = 'json'
      // so the response is parsed
      if (cb) {
        let data;
        try {
          data = JSON.parse(xhr.responseText);
        } catch (e) {
          data = null;
        }
        cb(data, xhr);
      }
    }
  };

  // Send
  xhr.send();

  // Return request
  return xhr;
}



// WEBPACK FOOTER //
// ./src/http.js